(() => {
  if (window.recordingCompanion) { window.recordingCompanion.init(document); return; }
  const instances = new Map();
  function init(root) {
    root.querySelectorAll('[data-recording-companion]').forEach(section => {
      if (instances.has(section)) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const elements = [...section.querySelectorAll('.recording-companion__intro, .recording-companion__item')];
      const animations = new Map();
      const controller = new AbortController();
      let observer;
      function reveal(element) {
        observer?.unobserve(element);
        element.classList.remove('is-reveal-pending');
        animations.get(element)?.cancel();
        animations.delete(element);
      }
      if (!reduced.matches && 'IntersectionObserver' in window && Element.prototype.animate) {
        observer = new IntersectionObserver(entries => {
          entries.filter(entry => entry.isIntersecting)
            .sort((a, b) => elements.indexOf(a.target) - elements.indexOf(b.target))
            .forEach(({ target }, index) => {
              reveal(target);
              const animation = target.animate([
                { opacity: 0, transform: 'translateY(32px)' },
                { opacity: 1, transform: 'translateY(0)' }
              ], { duration: 750, delay: index * 150, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' });
              animations.set(target, animation);
              animation.finished.then(() => animations.delete(target), () => animations.delete(target));
            });
        }, { threshold: .08, rootMargin: '0px 0px -20px 0px' });
        elements.forEach(element => { element.classList.add('is-reveal-pending'); observer.observe(element); });
      }
      reduced.addEventListener('change', () => {
        if (reduced.matches) { observer?.disconnect(); elements.forEach(reveal); }
      }, { signal: controller.signal });
      section.addEventListener('shopify:block:select', event => {
        const block = elements.find(element => element.dataset.companionBlock === event.detail.blockId);
        if (block) reveal(block);
      }, { signal: controller.signal });
      instances.set(section, () => {
        observer?.disconnect();
        elements.forEach(reveal);
        controller.abort();
      });
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-recording-companion]').forEach(section => {
      instances.get(section)?.();
      instances.delete(section);
    });
  });
  window.recordingCompanion = { init };
  init(document);
})();
